import { render } from "./turma_add_professor.vue?vue&type=template&id=257bc0d6&scoped=true"
import script from "./turma_add_professor.vue?vue&type=script&lang=js"
export * from "./turma_add_professor.vue?vue&type=script&lang=js"

import "./turma_add_professor.vue?vue&type=style&index=0&id=257bc0d6&lang=scss&scoped=true"
import "./turma_add_professor.vue?vue&type=style&index=1&id=257bc0d6&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"
import "./turma_add_professor.vue?vue&type=style&index=3&id=257bc0d6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257bc0d6"]])

export default __exports__